(function () {
  function init(root) {
    var dialog = root.querySelector('[data-rc-inquiry-dialog]');
    var openBtn = root.querySelector('[data-rc-inquiry-open]');
    if (!dialog || !openBtn) return;
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      document.documentElement.classList.add('rc-inquiry-lock');
      var first = dialog.querySelector('input:not([type=hidden]):not([readonly]), select, textarea, .rc-inquiry__close');
      if (first) first.focus();
    }
    function close() {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    }
    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('rc-inquiry-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    });
    openBtn.addEventListener('click', open);
    root.querySelectorAll('[data-rc-inquiry-close]').forEach(function (b) { b.addEventListener('click', close); });
    // click on backdrop closes
    dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
    // Esc closes (native for <dialog>); fallback + focus trap for browsers without showModal
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = dialog.querySelectorAll('a[href], button:not([disabled]), input:not([type=hidden]):not([disabled]), select, textarea');
      if (!f.length) return;
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    });
    // Re-open after a server round-trip (success or validation errors)
    if (dialog.querySelector('[data-rc-inquiry-success], [data-rc-inquiry-error]')) open();

    // Simple client-side required-field check with accessible messages
    var form = dialog.querySelector('form');
    if (form) form.addEventListener('submit', function (e) {
      var invalid = form.querySelector(':invalid');
      if (invalid) { e.preventDefault(); invalid.reportValidity ? invalid.reportValidity() : invalid.focus(); }
    });
  }
  function boot() { document.querySelectorAll('[data-rc-inquiry]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
